import { DocumentsList } from '../../documents/components';
import { useFolderTree } from '../context';
import { Folder } from '../models';
import { FolderHeader } from './folder-header.component';

type FolderDetailsProps = {
  selectedFolder: Folder;
  onShareFolderClick: () => void;
};

export const FolderDetails: React.FC<FolderDetailsProps> = ({
  selectedFolder,
  onShareFolderClick,
}) => {
  const { refetch, handleSelectFolder } = useFolderTree();

  return (
    <>
      <FolderHeader
        selectedFolder={selectedFolder}
        onShareFolderClick={onShareFolderClick}
      />

      <hr className="mb-6 border-t border-gray-100" />

      <DocumentsList
        folder={selectedFolder}
        onFolderTreeChange={refetch}
        onFolderChange={handleSelectFolder}
      />
    </>
  );
};
